<template>
  <div class="convention-hall page">
    <!-- 头部卡片：页面标题 + 功能小标签 + 数据统计展示 -->
    <div class="bc-top">
      <div class="bc-top2">
        <div class="font">{{ $t("concubine.Featured") }}</div>
        <!-- <div class="font">{{ $t("concubine.Checklist") }}</div> -->
      </div>
      <!-- 页面主标题 -->
      <div style="color: #fff; font-size: 1.4rem">
        {{ $t("concubine.concubine") }}
      </div>
      <!-- 副标题提示：切换城市 -->
      <div
        style="
          color: #fff;
          font-size: 0.6rem;
          width: 42vw;
          font-weight: lighter !important;
          margin-bottom: 0.5rem;
        "
      >
        {{ $t("concubine.switch_city") }}
      </div>

      <!-- 数据统计模块：展示服务数量、完成状态 -->
      <div class="bc-state">
        <div class="state">
          <div style="color: #feb974; font-weight: lighter !important">
            {{ $t("concubine.Serve") }}
          </div>
          <div style="font-size: 1.2rem">{{ addlist.length }}</div>
          <div style="color: #ccc; font-weight: lighter !important">
            {{ $t("concubine.Serve") }}
          </div>
        </div>
        <div class="state">
          <div style="color: #feb974; font-weight: lighter !important">
            {{ $t("concubine.information") }}
          </div>
          <div style="font-size: 1.2rem">{{ datalist.length}}</div>
          <div style="color: #ccc; font-weight: lighter !important">
            {{ $t("concubine.beautiful") }}
          </div>
        </div>
      </div>
    </div>

    <!-- 热门标题区域：展示热门标题 -->
    <div class="bc-hot">
      <div class="hot-title">{{ $t("concubine.Urban") }}</div>
      <div>{{ $t("concubine.consort") }}</div>
    </div>

    <!-- ====================== 地区选择导航栏 ====================== -->
    <div class="address-tab-wrap">
      <div
        class="address-tab-item"
        v-for="(val, key) in addlist"
        :key="key"
        :class="{ active: chooseActive.id === val.id }"
        @click="addgo(val)"
      >
        {{ val.name }}
      </div>
    </div>

    <!-- ====================== 下拉刷新 + 人员列表 ====================== -->
    <van-pull-refresh
      :pulling-text="$t('reservation.refresh')"
      :loosing-text="$t('reservation.refreshpage')"
      :loading-text="$t('reservation.refresh')"
      :success-text="$t('reservation.refresh')"
      border="false"
      class="list-wrapper"
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <!-- 人员列表项：点击进入详情 -->
      <div
        class="movie-item m-flex"
        @click="profile(v.id)"
        v-for="(v, k) in datalist"
        :key="k"
      >
        <!-- 人员头像 -->
        <van-image class="movie-img" round :src=" v.img_url">
          <template v-slot:loading>
            <van-loading type="circular" />
          </template>
        </van-image>
        <!-- 人员名称 -->
        <div class="m-f1 m-md2-l bc-flex">
          <div
            style="
              display: flex;
              justify-content: space-between;
              width: 100%;
              align-items: center;
              height: 2rem;
            "
          >
            <p>{{ v.xuanfei_name || $t("No information yet") }}</p>
            <div class="renzheng">
              <img src="../../assets/bc-img/V.png" alt="" />
              <div>{{ $t("index.Certification") }}</div>
            </div>
          </div>
          <!-- <div class="miaoshu" ><p>玛利西亚{{$t('concubine.lady')}}</p></div> -->
          <div class="shoufei" ><van-rate v-model="v.fee_star" size="15px" color="#FFD21D"/></div>
          <div class="shoufei" ><p>{{$t('concubine.height')}}</p><p class="shoufei">{{ v.height }} </p><p>{{$t('concubine.chest')}}</p>{{ v. bust}}</div>
          <div class="bc-btn">{{ $t('concubine.Make') }}</div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 加载更多按钮：数据满10条显示，点击加载下一页 -->
    <div class="next" v-if="datalist.length >= 10" @click="nextList()">
      {{ $t("index.next") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addlist: [], // 城市/地区列表数据
      chooseActive: {}, // 当前选中的城市对象（控制高亮）
      address_show: false, // 旧版地区弹窗开关（未使用）
      vod_name: "", // 备用字段
      isLoading: false, // 下拉刷新 loading 状态
      datalist: [], // 人员列表数据
      choose_page: 1, // 分页页码（默认第1页）,
      value:3,
    };
  },
  methods: {
    regionNames() {
      return ["台灣", "馬來西亞", "新加坡", "泰國"];
    },
    normalizeAddressList(list) {
      const names = this.regionNames();
      return (Array.isArray(list) ? list : []).slice(0, names.length).map((item, index) => ({
        ...item,
        name: names[index],
      }));
    },
    applyCachedChooseData() {
      const cache = localStorage.getItem("choose_page_cache");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.addlist = this.normalizeAddressList(parsed.addlist);
        this.chooseActive = parsed.chooseActive || {};
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        const active = this.addlist.find((item) => item.id === this.chooseActive.id);
        if (active) {
          this.chooseActive = active;
        }
        return this.addlist.length > 0 || this.datalist.length > 0;
      } catch (error) {
        return false;
      }
    },
    persistChooseData() {
      localStorage.setItem(
        "choose_page_cache",
        JSON.stringify({
          addlist: this.addlist,
          chooseActive: this.chooseActive,
          datalist: this.datalist,
        })
      );
    },
    /**
     * 加载更多
     * 功能：页码+1，请求下一页人员数据
     */
    nextList() {
      this.choose_page += 1;
      this.getxuanfeilist();
    },

    /**
     * 下拉刷新
     * 功能：清空列表 → 重置页码 → 重新请求第一页
     */
    onRefresh() {
      this.datalist = [];
      this.choose_page = 1;
      this.getxuanfeilist().finally(() => {
        this.isLoading = false;
      });
    },

    /**
     * 获取人员列表
     * 接口：xuanfeilist
     * 参数：page 页码、adsid 城市ID
     */
    getxuanfeilist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          page: this.choose_page,
          class_id: this.chooseActive.id,
          // plain_json:1
        },
      }).then((res) => {
        const list = Array.isArray(res.data.list) ? res.data.list : [];
        if (list.length > 0) {
          if (this.choose_page === 1) {
            this.datalist = list;
          } else {
            const currentIds = new Set(this.datalist.map((item) => item.id));
            const nextItems = list.filter((item) => !currentIds.has(item.id));
            this.datalist.push(...nextItems);
          }
          this.persistChooseData();
        } else {
          if (this.choose_page > 1) this.choose_page -= 1;
        }
      });
    },

    /**
     * 跳转人员详情页
     * @param {Number} id 人员ID
     */
    profile(id) {
      this.$router.push({
        path:
          "/profile?id=" +
          id +
          "&name=" +
          this.chooseActive.name +
          "&adsid=" +
          this.chooseActive.id,
      });
    },

    /**
     * 切换城市（核心功能）
     * @param {Object} data 选中的城市对象
     * 功能：切换城市 → 清空列表 → 重置页码 → 请求新数据
     */
    
    addgo(data) {
      // 未登录则跳转到登录页
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      this.chooseActive = data; // 更新当前选中城市
      this.datalist = []; // 清空旧列表
      this.choose_page = 1; // 重置页码
      this.persistChooseData();
      this.getxuanfeilist(); // 请求新城市的人员列表
    },

    /**
     * 获取城市列表
     * 接口：address_list
     * 功能：获取城市数据 → 默认选中第一个
     */
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.addlist = this.normalizeAddressList(res.data);
        const hasCachedActive =
          this.chooseActive && this.chooseActive.id && this.addlist.some((item) => item.id === this.chooseActive.id);
        this.chooseActive = hasCachedActive
          ? this.addlist.find((item) => item.id === this.chooseActive.id)
          : (this.addlist[0] || {});
        this.persistChooseData();
        this.getxuanfeilist();
      });
    },
  },
  created() {
    // 页面初始化：加载城市列表
    this.applyCachedChooseData();
    this.getAddress();
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";
::v-deep .van-image--round {
  border-radius: 1rem !important;
}
::v-deep .van-pull-refresh{
  padding-bottom:5rem ;
}
.bc-btn{
  width: 100%;
  height: auto;
  color: #000;
  background:linear-gradient(to right, #FFCD84, #FFB16E);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.6rem;
  padding: 0.4rem 0;
  border-radius: 0.5rem;
}
.shoufei{
  font-size: 0.6rem;
  color: #fff;
  font-weight: lighter !important;
  display: flex;
  align-items: center;
  p{
    margin-right: 0.5rem;
  }
}
.miaoshu {
  background-color: #168aff;
  border-radius: 1rem;
  font-size: 0.5rem;
  padding: 0 0.4rem;
  height: 2.5vh;
  display: flex;
  align-items: center;
  p{
    font-size: 0.5rem;
  }
}
.bc-flex {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  .renzheng {
    display: flex;
    width: auto;
    height: 3vh;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    border: 1px solid #555;
    padding: 0.2rem 0.5rem;
    border-radius: 1rem;
    div {
      font-size: 0.6rem;
      color: #beb183;
    }
  }
  img {
    width: 0.7rem;
  }
}
/* 头部统计卡片样式 */
.bc-state {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 0.5rem;
  .state {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    background-color: #000;
    width: 49%;
    color: #fff;
    font-size: 0.6rem;
    padding: 1rem 1rem 0.6rem 1rem;
    border-radius: 1rem;
  }
}

/* 热门标题区域样式 */
.bc-hot {
  color: #fff;
  font-size: 1.2rem;
  padding: 0 1rem 0rem 0.5rem ;
}
.hot-title {
  color: #8c835f;
  font-weight: lighter !important;
  font-size: 0.7rem;
}

/* 头部整体背景卡片 */
.bc-top {
  display: flex;
  flex-direction: column;
  background: linear-gradient(to right, #47362f, #403438);
  padding: 0.2rem 0.6rem;
  border-bottom: 1px solid #989898;
  width: auto;
  margin: 0.5rem;
  border-radius: 1rem;
}
.bc-top2 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0.5rem 0 0.2rem;
  border-radius: 1rem;
}
.font {
  color: #ffc57d;
  font-weight: lighter !important;
  font-size: 0.6rem;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 2rem;
  border: 1px solid #989898;
  width: auto;
}

/* 加载更多按钮 */
.next {
  padding: @pd1;
  color: @theme2;
  text-align: center;
  margin-bottom: 5rem;
}

/* 人员列表项样式 */
.movie-item {
  position: relative;
  margin: @md1;
  padding: @pd1;
  // background-color: #0C0C0E;
  border: 1px solid #444;
  border-radius: @br1;
  color: @white;
  display: flex;
  align-items: flex-start;
}
.movie-img {
  width: 20vw;
  height: 22vw;
  /deep/ img {
    padding: 0;
  }
}

/* 横向地区标签样式 */
.address-tab-wrap {
  width: 100%;
  margin: 0 auto;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 0.5rem 0;
  scrollbar-width: none;
  background: transparent;
  &::-webkit-scrollbar {
    display: none;
  }
}
.address-tab-item {
  padding: 0.3rem 1rem;
  margin: 0 0.8rem;
  font-size: 1rem;
  color: #999;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  &.active {
    color: #feb974;
    font-weight: 600;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40%;
      height: 10px;
      background-color: #feb974;
      border-radius: 1rem;
    }
  }
  &:hover {
    color: #f0a860;
  }
}

/* 页面全局布局 */
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: @page_bg;
}
.convention-hall {
  display: flex;
  flex-direction: column;
  height: max-content;
}
</style>
